import { Button, Grid } from '@mui/material';
import { useSnackDispatchContext } from '../contexts/NotificationBarContext';


export default function OpenInBrowserCTA(setShowOpenInBrowser:any) {
  const currentUrl = window.location.href;
  const snackDispatch: any = useSnackDispatchContext();

  const openInChrome = () => {

    const chromeUrl = currentUrl.replace(/^https?:\/\//, "googlechrome://");
    window.location.href = chromeUrl;

    setTimeout(() => {
      window.location.href = currentUrl;
    }, 1500);
  };

  const processWithoutOneClick = () => {
    // USER Moves to OTP
    snackDispatch({ type: "showFailed", msg: "Coninuing OTP flow..." })
    setTimeout(()=>{
      setShowOpenInBrowser(false)
    },1000)
  }

//   const openInSafari = () => {
//     // Safari doesn’t need a special scheme—just reload in external browser context.
//     // In many in-app browsers, this won’t escape; so show instructions as well.
//     window.location.href = currentUrl;
//   };

  return (
    <Grid sx={{ flexGrow: 1 }} direction={"column"} container justifyContent={"center"} alignItems={"center"} gap={"2rem"}>
      {/* <p>Passkeys aren’t supported here. Open this page in actual browser to use Passkeys:</p> */}
      <p>One Click Login isn’t supported here. Open this page in actual browser for seamless experience:</p>
      <Grid sx={{ flexGrow: 1 }} direction={"row"} container justifyContent={"center"} alignItems={"center"} gap={"2rem"}>
      <Button onClick={openInChrome} variant="contained">
        Open in Chrome
      </Button>
      <Button onClick={processWithoutOneClick} variant="contained">
        Continue Without OneClick
      </Button>
      </Grid>
    </Grid>
  );
}